import React, { useEffect, useRef, useState } from 'react';
import Hls from 'hls.js';
import styled from 'styled-components';

const ThumbnailWrapper = styled.div`
  cursor: pointer;
  margin: 0 auto;
  position: relative;
  width: fit-content;

  &:before {
    background: rgba(0, 0, 0, 0.5);
    border-radius: 70px;
    content: ' ';
    display: block;
    height: 90px;
    left: 50%;
    margin: -45px 0 0 -45px;
    position: absolute;
    top: 50%;
    width: 90px;
  }
  &:after {
    border-bottom: solid 20px transparent;
    border-left: solid 20px #fff;
    border-right: solid 20px transparent;
    border-top: solid 20px transparent;
    content: ' ';
    display: block;
    height: 0px;
    left: 50%;
    margin: -19px 0 0 -7px;
    position: absolute;
    top: 50%;
    width: 0px;
  }
`;
const Thumbnail = styled.img`
  width: 100%;
  max-width: 300px;
`;

export default function VideoPlayer({ playbackUrl, thumbnailUrl = null }) {
  const videoRef = useRef(null);
  const thumbnailRef = useRef(null);
  const [thumbnailMode, setThumbnailMode] = useState(true);
  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);
  const src = playbackUrl;

  useEffect(() => {
    if (thumbnailUrl) {
      setHeight(thumbnailRef.current.height);
      setWidth(thumbnailRef.current.width);
    } else {
      setThumbnailMode(false);
    }

    return () => {
      if (hls) {
        hls.destroy();
      }
    };
  }, [videoRef]);

  useEffect(() => {
    let hls;
    if (videoRef.current) {
      const video = videoRef.current;

      if (video.canPlayType('application/vnd.apple.mpegurl')) {
        // Some browers (safari and ie edge) support HLS natively
        video.src = src;
      } else if (Hls.isSupported()) {
        // This will run in all other modern browsers
        hls = new Hls();
        hls.loadSource(src);
        hls.attachMedia(video);
      } else {
        console.error("This is a legacy browser that doesn't support MSE");
      }
    }
  }, [thumbnailMode, videoRef]);

  if (thumbnailMode && thumbnailUrl) {
    return (
      <ThumbnailWrapper onClick={() => setThumbnailMode(false)}>
        <Thumbnail src={thumbnailUrl} ref={thumbnailRef} />
      </ThumbnailWrapper>
    );
  }

  return (
    <video
      controls
      poster={thumbnailUrl}
      autoPlay={!!thumbnailUrl}
      ref={videoRef}
      style={{
        width: width,
        height: height,
        maxWidth: '100%',
        margin: '0 auto',
        display: 'block',
      }}
    />
  );
}
